export enum GroupingOption {
  Team = "TEAM",
  Task = "TASK",
  Resource = "RESOURCE",
}
